export const LANDING_PAGE = 'dashboard';
export const ERROR_KEYS = {
    user_account_not_exists: 'userAccountNotExists',
    session_expired: 'sessionExpired',
};
export const OFFICIAL_PROCESS = 'drafts/officialprocess';

export const BPMN_PATH = 'processes';

export const CDN_DT_URL = 'https://cdn.dt.bluedolphin.app/';
export const CDN_PROD_URL = 'https://cdn.bluedolphin.app/';
